import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES } from "../../content/site";
import { Reveal } from "../motion";
import { Eyebrow } from "../Brand";

const TILES = [
  { to: "/sermons", label: "The Vault", sub: "Watch. Learn. Be equipped.", n: "01", span: "lg:col-span-7", tall: true },
  { to: "/identity", label: "Our Identity", sub: "A house of prayer, proclamation, worship & discipleship.", n: "02", span: "lg:col-span-5", image: IMAGES.prayer, alt: "A man kneeling in prayer at the altar" },
  { to: "/leadership", label: "Leadership", sub: "Meet those who serve GNP.", n: "03", span: "lg:col-span-5", image: IMAGES.isaiah, alt: "Minister Isaiah Harvey preaching" },
  { to: "/ministries", label: "Ministries", sub: "Sunday worship, midweek discipleship, Saturday outreach.", n: "04", span: "lg:col-span-7", image: IMAGES.bibleStudy, alt: "GNP Bible study gathered in prayer" },
];

function Tile({ t }) {
  return (
    <Link to={t.to} className={`group relative flex min-h-[260px] flex-col justify-between overflow-hidden bg-[#090909] p-7 sm:p-10 lg:min-h-[340px] ${t.span}`} data-testid={`explore-tile-${t.label.toLowerCase().replace(/\s+/g, "-")}`}>
      {t.image && (
        <img src={t.image} alt={t.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-35 grayscale transition-[opacity,transform,filter] duration-700 group-hover:scale-105 group-hover:opacity-55 group-hover:grayscale-0" />
      )}
      <div className="absolute inset-0 bg-[#781C31] opacity-0 transition-opacity duration-500 group-hover:opacity-20" />
      <div className="relative flex items-start justify-between">
        <span className="font-display text-xs tracking-[0.3em] text-[#B9AFB2]">{t.n}</span>
        <ArrowUpRight className="h-6 w-6 text-[#F6F2F0] transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1" aria-hidden="true" />
      </div>
      <div className="relative">
        <h3 className="font-display text-5xl font-bold uppercase leading-none tracking-tight text-[#F6F2F0] sm:text-6xl">{t.label}</h3>
        <p className="mt-3 max-w-sm text-sm text-[#F6F2F0]/80 sm:text-base">{t.sub}</p>
      </div>
    </Link>
  );
}

export function Explore() {
  return (
    <section className="bg-[#090909] py-24 lg:py-32" data-testid="home-explore">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <Eyebrow>Go Deeper</Eyebrow>
        <h2 className="mt-6 font-display text-3xl font-semibold uppercase tracking-tight text-[#F6F2F0] sm:text-4xl">Find your place in the mission.</h2>
        <Reveal className="mt-12 grid gap-px border border-[#F6F2F0]/10 bg-[#F6F2F0]/10 lg:grid-cols-12">
          {TILES.map((t) => <Tile key={t.to} t={t} />)}
        </Reveal>
      </div>
    </section>
  );
}
